function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "currentColor"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M27.5 59.5C27.5 77.45 42.05 92 60 92c15.63 0 28.682-11.032 31.795-25.734-4.749.029-8.068-3.005-9.271-8.789-12.508-.23-21.61-8.907-21.613-20.134-4.034-1.783-6.626-5.518-7.06-9.762C38.84 30.455 27.5 43.653 27.5 59.5zM60 97c-20.71 0-37.5-16.79-37.5-37.5S39.29 22 60 22c-3.089 5.358 0 11.454 6.37 11.454-2.565 11.034 6.368 21.045 20.655 18.693 0 9.51 3.588 10.96 10.475 7.353C97.5 80.21 80.71 97 60 97z"
}), React.createElement("circle", {
  cx: 69,
  cy: 25,
  r: 3,
  fill: "#FFF"
}), React.createElement("circle", {
  cx: 79.528,
  cy: 45.083,
  r: 2.321,
  fill: "#FFF"
}), React.createElement("circle", {
  cx: 92.548,
  cy: 46.964,
  r: 3.202,
  fill: "#FFF"
}), React.createElement("circle", {
  cx: 79.808,
  cy: 32.363,
  r: 4.363,
  fill: "#FFF"
}), React.createElement("circle", {
  cx: 47.933,
  cy: 71.705,
  r: 4.598,
  fill: "#FFF"
}), React.createElement("circle", {
  cx: 47.933,
  cy: 48.833,
  r: 3.75,
  fill: "#FFF"
}), React.createElement("circle", {
  cx: 71.881,
  cy: 71.559,
  r: 5.881,
  fill: "#FFF"
}));

var SvgIconCookie = function SvgIconCookie(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCookie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cookie.b3ec2b79.svg";
export { ForwardRef as ReactComponent };